import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { doPreBootstrap } from './main.prebootstrap';

// Check if we're in preview mode - if so, skip the bootstrap context fetch
const isPreviewMode = window.location.pathname.includes('/preview');

if (isPreviewMode) {
  // In preview mode, provide default context and bootstrap immediately
  localStorage.setItem(
    'fspDiscoveryFlightContext',
    JSON.stringify({
      apiEnvironment: 'preview',
      discoveryFlightApiUrl: 'preview',
      recaptchaKey: 'preview',
      subscriptionKey: 'preview',
      payrixBaseUrl: 'preview',
      payrixPayFieldsScriptUrl: 'preview',
      payrixApiKey: 'preview',
    }),
  );

  bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch((err) =>
    console.error(err),
  );
} else {
  // Normal mode - fetch context first
  doPreBootstrap()
    .then(() => {
      bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch((err) =>
        console.error(err),
      );
    })
    .catch((error) => {
      console.error('Discovery Flight App Bootstrap Failure', error);
      // Add any error handling logic here if needed
    });
}
